import { defineStore } from "pinia"

import deliveryService from "@/services/deliveryService"
import syncService from "@/services/syncService"

type MetaState = {
  deliveryPolitics: any[]
  fetchingPolitics: boolean
}

export const useSyncMetaStore = defineStore("syncMeta", {
  state: (): MetaState => ({
    deliveryPolitics: [],
    fetchingPolitics: false
  }),

  getters: {},

  actions: {
    async getAllActiveDeliveries() {
      this.fetchingPolitics = true
      try {
        const response = await deliveryService.getAllActive()

        this.deliveryPolitics = response.data.results || []
      } catch (e) {
        console.error(e)
      } finally {
        this.fetchingPolitics = false
      }
    }
  }
})
